<template>
    <PageFull header="Кошелек" type="white" :fullwidth="true" :nopadding="false">
        <template v-slot:body>
            <div class="w-full p-0">                            
                <div v-if="wallet" class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row" >
                    <div class="w-full flex flex-column" >

                        <span v-if="wallet && wallet.id">id: {{ wallet.id }}</span><br>
                        <span v-if="wallet && wallet.user_id">user_id: {{ wallet.user_id }}</span><br>
                        <span v-if="wallet && wallet.ext_type">Тип: {{ wallet.ext_type }}</span><br>
                        <span v-if="wallet && wallet.created_at">Создан: {{ formatDate(wallet.created_at) }}</span><br>
                        <span v-if="wallet && wallet.updated_at">Обновлен: {{ formatDate(wallet.updated_at) }}</span><br>
                        <span v-if="wallet && wallet.description">Описание: {{ wallet.description }}</span><br>

                        <AccountList v-if="wallet.accounts" :accounts="wallet.account_details" :total="totalRecords" :loading="loading"
                            @filter="setFilter" @lazyParams="setParams" :defaultParams="lazyParams" />

                    </div>
                </div>
                <Skeleton height="2rem" v-else />
            </div>
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import { useRoute } from 'vue-router'
import PageFull from '@/components/public/page.vue'
import AccountList from '@/components/admin/account/list.vue'

export default {
    data() {
        return {
            // wallet_id: null,
            wallet: null,
            accounts: null,
            lazyParams: {
                first: 0,
                rows: 20,
                sort: null,
                sortField: null,
                sortOrder: null,
                filters: {},
            },
            totalRecords: 0,
            loading: false,
        }
    },
    components: {
        PageFull,
        AccountList
    },
    methods: {
        formatDate(value) {
            return this.helper.format_date(value)
        },
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.loadLazyData();
        },
        setParams(params) {
            this.lazyParams = params
            this.loadLazyData()
        },
        async loadLazyData() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' }) //скролл вверх
            const wallet = await this.connect.GetAdminWallet(this.wallet_id).then(res => res)
            if (wallet.result && wallet.data) {
                // 
                this.wallet = wallet.data
                this.accounts = wallet.data.accounts
                this.totalRecords = wallet.data.accounts.length
            }
            this.loading = false
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        const route = useRoute()
        if(route.params.id!='' && this.helper.is_id(route.params.id)){
            this.wallet_id = route.params.id            
        }
    },
    async mounted() {
        this.loadLazyData();
    },
}
</script>